var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"outlined":"","label":_vm.getLabel(),"dense":"","data-testid":"senderSmsSender"},model:{value:(_vm.sender),callback:function ($$v) {_vm.sender=$$v},expression:"sender"}}),(_vm.validationErrors)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.validationErrors)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }